import handleOwaDateError from './handleOwaDateError';
import Entity from 'txp-data/lib/schema/Entity';
import tryCreateUtcDate from './tryCreateUtcDate';

export default function tryCreateTxpUtcDate(dateTime: string, entity: Entity): boolean {
    return tryCreateUtcDate(dateTime, (e: Error) => {
        handleOwaDateError(e, entity);
    });
}
